import { combineReducers } from 'redux';

import autocomplete from 'app/shared/reducers/address/autocomplete';
import details from 'app/shared/reducers/address/details';

const rootAddressReducer = combineReducers({
    autocomplete,
    details,
});

export default rootAddressReducer;
